<div
  [style]="dataPlateStyle"
  *ngIf="isFirst"
  [style.top]="reportDataPlate.titleTop"
  [style.Left]="reportDataPlate.titleLeft"
  [style.width]="reportDataPlate.titleWidth"
  [style.height]="reportDataPlate.titleHeight"
  [style.z-index]="reportDataPlate.titleZIndex"
  [style.border]="reportDataPlate.titleBorderStyle"
  [style.border-color]="reportDataPlate.titleBorderColor"
  [style.border-width]="reportDataPlate.titleBorderWidth"
  [style.background-color]="reportDataPlate.titleBackgroundColor"
  [style.justify-content]="reportDataPlate.titleJustifyContent"
  [style.align-items]="reportDataPlate.titleAlignItems"
  [style.padding-right]="reportDataPlate.titlePaddingRight"
  [style.padding-bottom]="reportDataPlate.titlePaddingBottom"
  [style.padding-left]="reportDataPlate.titlePaddingLeft"
  [style.padding-top]="reportDataPlate.titlePaddingTop"
>
  <div
    [style]="textInlineStyle"
    [style.color]="reportDataPlate.titleFontColor"
    [style.font-size]="reportDataPlate.titleFontSize"
    [style.font-family]="reportDataPlate.titleFontFamily"
    [style.font-style]="reportDataPlate.titleFontStyle"
    [style.font-weight]="reportDataPlate.titleFontWeight"
    [style.text-align]="reportDataPlate.titleTextAlign"
    [style.verticalAlign]="reportDataPlate.titleVerticalAlign"
    [style.line-height]="reportDataPlate.titleLineHeight"
  >
    <ng-container>{{ reportDataPlate.titleText }}</ng-container>
  </div>
</div>
<div [ngStyle]="getBaseComponentStyle()">
  <ng-container *ngFor="let image of images; index as i">
    <div [ngStyle]="getDivComponentStyle(i, sizeUnit)">
      <div *ngIf="title.position === 'top'">
        <div id="title.id" [ngStyle]="getTitleComponentStyle(sizeUnit, title)" style="overflow: hidden">
          <div [ngStyle]="getTextAreaTableStyle(title)">
            <div [ngStyle]="getTextAreaTableCellStyle(title)">{{ getTitleContext(title, image.caption) }}</div>
          </div>
        </div>
      </div>
      <app-report-column-image
        [image]="image"
        [isColumnStyle]="false"
        [sizeUnit]="sizeUnit"
        [width]="getImageWidth(image)"
        [height]="getImageHeight(image)"
        [maxWidth]="getImageMaxWidth()"
        [maxHeight]="getImageMaxHeight()"
        [isAbsolute]="true"
        [top]="getImageY(image)"
        [left]="image.x"
        [reportDataPlate]="reportDataPlate"
      >
      </app-report-column-image>
      <div *ngIf="title.position === 'bottom'">
        <div id="title.id" [ngStyle]="getTitleComponentStyle(sizeUnit, title)" style="overflow: hidden">
          <div [ngStyle]="getTextAreaTableStyle(title)">
            <div [ngStyle]="getTextAreaTableCellStyle(title)">{{ getTitleContext(title, image.caption) }}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
